import styled from 'styled-components';
import { fonts } from 'styles';
import imageHeader from 'assets/images/header.jpg';

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-height: 100vh;
  background-color: #161a1e;

  @media screen and (max-width: 1023px) {
    flex-direction: column;
    max-height: max-content;

    background-color: #fff;
  }
`;

export const Content = styled.section`
  display: flex;
  column-gap: 96px;

  @media screen and (max-width: 1023px) {
    flex-direction: column;
    max-height: max-content;
  }
`;

export const PhotoHeader = styled.img.attrs({ src: imageHeader })`
  height: 100vh;

  @media screen and (max-width: 1023px) {
    width: 100%;
    max-width: unset;
    height: unset;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 332px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 1023px) {
    max-width: unset;
    align-items: center;
    padding: 48px;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 60px;
  line-height: 64px;
  letter-spacing: -0.05em;
  color: #fff;
  text-transform: uppercase;
  margin-bottom: 16px;

  @media screen and (max-width: 1023px) {
    text-align: center;
    color: #111;
    span {
      color: #111;
    }
  }

  @media screen and (max-width: 500px) {
    font-size: 30px;
    line-height: 34px;
    letter-spacing: -0.06em;
  }
`;

export const Subtitle = styled.article`
  font-family: 'Playfair Display', serif;
  font-size: 28px;
  line-height: 34px;
  color: #ccd8d9;
  margin-bottom: 64px;

  @media screen and (max-width: 1023px) {
    color: #3d3d3d;
    text-align: center;
  }

  @media screen and (max-width: 500px) {
    font-size: 23px;
    line-height: 28px;
  }
`;

export const Credit = styled.div`
  font-family: ${fonts.BentonSansRegular};
  font-size: 18px;
  line-height: 22px;
  color: #fff;

  br {
    display: none;
  }
  span {
    margin: 0 16px;
  }

  @media screen and (max-width: 1023px) {
    color: #111;
    border-bottom: 1px solid #111;
    padding: 0 32px 32px 32px;
    width: max-content;
    margin: 0 auto;
  }

  @media screen and (max-width: 500px) {
    width: 100%;
    text-align: center;

    br {
      display: block;
    }
    span {
      display: none;
    }
  }
`;
